import script from "./right-rank.vue?vue&type=script&setup=true&lang=ts"
export * from "./right-rank.vue?vue&type=script&setup=true&lang=ts"

import "./right-rank.vue?vue&type=style&index=0&id=59a0d6b8&scoped=true&lang=stylus"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59a0d6b8"]])

export default __exports__